import { Checkbox } from './Checkbox/Checkbox';
import { CheckboxState, CheckboxTreeNodeType } from './CheckboxTree.types';

type CheckboxTreeNodeProps = {
	value: string;
	label: string;
	state: CheckboxState;
	descendants?: CheckboxTreeNodeType[];
	onToggle: (nodeValue: string, newState: CheckboxState) => void;
	valuesWithCheckedAncestors: Set<string>;
};

export const CheckboxTreeNode: React.FC<CheckboxTreeNodeProps> = ({
	value,
	label,
	state,
	descendants,
	onToggle,
	valuesWithCheckedAncestors,
}) => {
	const onChange = () => {
		const newState: CheckboxState =
			state === CheckboxState.Unchecked ||
			state === CheckboxState.Indeterminate
				? CheckboxState.Checked
				: CheckboxState.Unchecked;
		onToggle(value, newState);
	};

	const hasCheckedAncestor = valuesWithCheckedAncestors.has(value);
	const computedState =
		hasCheckedAncestor && state === CheckboxState.Checked
			? CheckboxState.ImplicitlyChecked
			: state;

	return (
		<div>
			<Checkbox
				value={value}
				label={label}
				state={computedState}
				onChange={onChange}
			/>
			{descendants && (
				<div style={{ marginLeft: '20px' }}>
					{descendants.map((child: any) => (
						<CheckboxTreeNode
							key={child.value}
							value={child.value}
							label={child.label}
							state={child.state}
							descendants={child.children}
							onToggle={onToggle}
							valuesWithCheckedAncestors={
								valuesWithCheckedAncestors
							}
						/>
					))}
				</div>
			)}
		</div>
	);
};
